import { Button } from "@amzn/stencil-react-components/button";
import { Col } from "@amzn/stencil-react-components/layout";
import { ModalContent } from "@amzn/stencil-react-components/modal";
import { IItemVersion } from "@/common/types/item.types";
import { SelectChildSku } from "@/pages/HardwareDetails/components/SelectChildSku/select-child-sku";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React, { useState } from "react";

const MODAL_WIDTH = 600;

export interface ChangeVersionModalProps {
  close: () => void;
  versions: IItemVersion[];
  selectedVersion: IItemVersion;
  onConfirm: (version: IItemVersion) => void;
}

export const ChangeVersionModal: React.FC<ChangeVersionModalProps> = ({
  close,
  versions,
  selectedVersion,
  onConfirm,
}) => {
  const [tempVersion, setTempVersion] = useState<IItemVersion>(selectedVersion);

  const handleConfirm = () => {
    onConfirm(tempVersion);
    close();
  };

  return (
    <ModalContent
      data-testid="change-version-modal"
      titleText={getString("checkout.sidePanel.changeVersion")}
      maxWidth={null}
      buttons={[
        <Button key="cancel-button" dataTestId="cancel-version-button" onClick={close}>
          {getString("checkout.sidePanel.modal.cancelButton")}
        </Button>,
        <Button key="save-button" dataTestId="save-version-button" onClick={handleConfirm}>
          {getString("checkout.sidePanel.modal.saveButton")}
        </Button>,
      ]}
    >
      <Col width={MODAL_WIDTH}>
        <SelectChildSku versions={versions} selectedVersion={tempVersion} onChange={setTempVersion} alwaysRadio />
      </Col>
    </ModalContent>
  );
};
